import {
  getCurrentStage,
  getBookInputs,
  getCompletedFields,
} from '../reducers';
import { storeSessionData } from '../../modules/SessionStore';

export default getState => {
  const newState = getState();

  const stage = getCurrentStage(newState);
  const data = getBookInputs(newState);
  const progress = getCompletedFields(newState);

  storeSessionData({ stage, data, progress });
};
